import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { DeepLinkAliasField } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';

import { SpaceType } from 'APP/model/space/spaceModel.types';

import { ISpaceFormData } from '../SpaceForm.presenter';

export const SpaceDeepLinkAliasField: FC<FieldRenderProps<string, HTMLInputElement>> = ({
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <DeepLinkAliasField
      title={t('space_permanent_link')}
      description={t('space_deeplink_prompt')}
      placeholder={t('common_link')}
      validatingText={t('checking_deeplink')}
      successText={t('space_link_is_available')}
      isShowLink={(values: ISpaceFormData): boolean => values.type === SpaceType.Public}
      {...props}
    ></DeepLinkAliasField>
  );
};
